import { isSSRServer } from '@/config';
import { numberFormat, formatUnitsNumber } from '@/common/format';
export const SELECT_SPLIT = ',';
export const RANGE_SPLIT = ',';
export const CHECKBOX_SPLIT = ',';
export const TAG_INPUT_SPLIT = ',';
export const SAVE_SEARCH_STATUS = {
    save: 'SAVE',
    search: 'SEARCH',
    listing: 'LISTING'
};
export const mobileOutFields = [
    'minPrice-maxPrice',
    'More-Than-Beds',
    'More-Than-Baths'
];
export const brokerMobileOutFields = [];
export const DATA_TYPE_MAP = {
    year: 'year',
    sqft: 'sqft',
    money: 'money',
    float: 'float',
    days: 'days',
    date: 'date',
    none: 'none'
};

export function getRecentlySearch() {
    if (!isSSRServer) {
        try {
            const sessionStorage = window.sessionStorage;
            const recentlySearch = sessionStorage.getItem('recently_search');
            if (recentlySearch) {
                return JSON.parse(decodeURIComponent(recentlySearch));
            } else {
                return [];
            }
        } catch (e) {
            console.log(e);
        }
    }
    return [];
}

export function setRecentlySearch(search) {
    if (!isSSRServer) {
        try {
            const sessionStorage = window.sessionStorage;
            sessionStorage.setItem(
                'recently_search',
                `${encodeURIComponent(JSON.stringify(search))}`
            );
        } catch (e) {
            console.log(e);
        }
    }
}

export function setRecentlyPropertyType(property) {
    if (!isSSRServer) {
        try {
            const localStorage = window.localStorage;
            localStorage.setItem(
                'recently-property-type',
                JSON.stringify(property)
            );
        } catch (e) {
            console.log(e);
        }
    }
}

export const selectLabels = (config, value) => {
    const labels = [];
    const values = value.split(SELECT_SPLIT);
    let option = {};
    if (config.args) {
        config.args.reduce((memo, cur) => {
            return (option[cur.value] = cur.label);
        }, option);
    }
    values.forEach(v => {
        option[v] && labels.push(option[v]);
    });
    return labels;
};

export const rangeLabels = (config, value = '', { currencySymbol }) => {
    const format = (v, units) => {
        if (config.mask === 'money') {
            if (units) {
                return currencySymbol + formatUnitsNumber(v);
            }
            return `${currencySymbol} ` + numberFormat(v, false);
        }
        return numberFormat(v, false);
    };
    let v = value.split(RANGE_SPLIT);
    const values = { 0: v[0] || '', 1: v[1] || '' };
    let minLabel = config?.args?.minLabel || '';
    let maxLabel = config?.args?.maxLabel || '';
    return [
        values[0]
            ? minLabel.replace('${value}', format(values[0], true), true)
            : '',
        values[1]
            ? maxLabel.replace('${value}', format(values[1], true), true)
            : ''
    ];
};
